import React from "react"

interface badgeProps {
    count?:    number
    cssClass:  string
    label:     string
    showZero?: boolean
}

const BadgeMessage: React.FC<badgeProps> = ({count = 0, cssClass, label, showZero = false}: badgeProps) => {

    return <span className={"message-badge " + cssClass}>
        {label}
        {(count > 0 || showZero) && <strong>&nbsp;{count}</strong>}
    </span>

}

export default BadgeMessage